// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__22WHF","actions":"GroupTable_actions__2lwPA","deleteModalFooter":"GroupTable_deleteModalFooter__3UcqN"};